export const watchAndBetEnabled: boolean = false;
